export const OrderStatesFilter = {
  title: 'Estado'
}



// WEBPACK FOOTER //
// ./src/translations/pt/components/OrderStatesFilter.js